module.exports = __webpack_public_path__ + "assets/4d7bd601e43d34e62fd53c30219b2733.mp3";